<template>
	<header class="main-header">
		<!-- Logo -->
		<a class="logo">
			<!-- mini logo for sidebar mini 50x50 pixels -->
			<span class="logo-mini"><b>VM</b></span>
			<!-- logo for regular state and mobile devices -->
			<span class="logo-lg">ViaMed</span>
		</a>

		<!-- Header Navbar: style can be found in header.less -->
		<nav class="navbar navbar-static-top">
			<!-- Sidebar toggle button-->
			<a class="sidebar-toggle" @click="toogleMenu">
				<span class="sr-only">Toggle navigation</span>
			</a>
		</nav>
	</header>
</template>
<script>
	export default {
		name: 'AppHeader',
		methods: {
			toogleMenu() {
				$('body').toggleClass('sidebar-collapse');
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cnt-app/components/header.vue